import React from "react";

import autoIcon from '../../icons/auto.svg';
import trainIcon from '../../icons/train.svg';
import planeIcon from '../../icons/plane.svg';
import hyperloopIcon from '../../icons/hyperloop2.svg';


export default class extends React.Component {
  render() {
    return (
      <section className="welcome section">
    <div className="container">
    <div className="row center-xs center-sm center-md center-lg">
      <div className="row center-xs center-sm center-md center-lg">
        <div className="col-xs-12">
          <h1 className="main-subheading">Научно-образовательный ресурс</h1>
          <h1 className="heading intro-heading">Механическое движение применительно к перемещению человека на большие расстояния</h1>
        </div>
        <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <a href="#auto">
            <div className="circle">
              <img alt='' className="responsive-svg" src={autoIcon} />
            </div>
          </a>
        </div>
        <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <a href="#train">
            <div className="circle">
              <img alt='' className="responsive-svg" src={trainIcon} />
            </div>
          </a>
        </div>
        <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <a href="#plane">
            <div className="circle">
              <img alt='' className="responsive-svg" src={planeIcon} />
            </div>
          </a>
        </div>
        <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <a href="#hyperloop">
            <div className="circle">
              <img alt='' className="responsive-svg" src={hyperloopIcon} />
            </div>
          </a>
        </div>
      </div>
    </div>
    </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/Intro.js